import { toast } from 'react-toastify';
import * as api from '../api/visitTasksApi';
import * as types from '../constants/visitTasksConstants';

export const getVisitTasksActions = (vin, visitId) => async (dispatch) => {
  dispatch({ type: types.GET_VISIT_TASKS_REQUEST });
  try {
    const { error, data } = await api.getVisitTasks(vin, visitId);
    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.GET_VISIT_TASKS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося завантажити список послуг візиту');
    dispatch({ type: types.GET_VISIT_TASKS_FAILURE });
  }
};

export const updateVisitTaskAction = (vin, visitId, taskId, task) => async () => {
  try {
    const { error } = await api.updateVisitTask(vin, visitId, taskId, task);
    if (error) {
      throw new Error(error);
    }
    toast.success('Послуга візиту була успішно змінена');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося змінити послугу візиту');
  }
};

export const createVisitTaskAction = (vin, visitId, task) => async () => {
  try {
    const { error } = await api.createVisitTask(vin, visitId, task);
    if (error) {
      throw new Error(error);
    }
    toast.success('Послуга візиту була успішно додана');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося додати послугу візиту');
  }
};

export const deleteVisitTaskAction = (vin, visitId, taskId) => async () => {
  try {
    const { error } = await api.deleteVisitTask(vin, visitId, taskId);
    if (error) {
      throw new Error(error);
    }
    toast.success('Послуга візиту була успішно видалена');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося видалити послугу візиту');
  }
};

export const clearSelectedVisitTaskAction = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_SELECTED_VISIT_TASK,
  });
};

export const clearVisitTasksActions = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_VISIT_TASKS,
  });
};

export const setSelectedVisitTaskAction = (task) => async (dispatch) => {
  dispatch({
    type: types.SELECT_VISIT_TASK,
    payload: task,
  });
};
